// Árboles activos de cada instalación, para elegir en la inspección diaria
// cuál árbol tiene la alerta o falla del ítem fitosanitario.
//
// Se leen de la base al abrir el asistente con señal (rpc
// cables_arboles_para_inspeccion) y se guardan aquí, en localStorage, con la
// hora de carga: arriba en las plataformas a veces no hay señal. La clave NO
// empieza con `cables-pin:` (salir del PIN la borraría y la lista no es de la
// persona, es de la instalación). Ningún fallo de localStorage lanza.

export const CLAVE_ARBOLES = 'cables-arboles:v1';

// Ítems del checklist en los que, con Alerta o Falla, se elige el árbol.
export const ITEMS_CON_ARBOL = ['estado_fitosanitario'];

export const claveArboles = (instalacion) => `${CLAVE_ARBOLES}:${instalacion || 'canopy'}`;

const texto = (v) => (typeof v === 'string' ? v.trim() : '');
const orden = new Intl.Collator('es', { numeric: true, sensitivity: 'base' });

// Filas de la rpc (o del caché) -> [{ id, codigo, especie, sostiene }] por código.
export const normalizarArboles = (filas) => {
  if (!Array.isArray(filas)) return [];
  return filas
    .filter((f) => f && typeof f === 'object' && texto(f.id) && texto(f.codigo))
    .map((f) => ({ id: texto(f.id), codigo: texto(f.codigo), especie: texto(f.especie), sostiene: texto(f.sostiene) }))
    .sort((a, b) => orden.compare(a.codigo, b.codigo));
};

// Lista de ids elegidos: solo textos, sin vacíos ni repetidos.
export const idsArboles = (v) => (Array.isArray(v)
  ? [...new Set(v.filter((x) => typeof x === 'string' && x))]
  : []);

export const guardarArbolesCache = (instalacion, arboles, at = Date.now()) => {
  try {
    localStorage.setItem(claveArboles(instalacion), JSON.stringify({ at, arboles: normalizarArboles(arboles) }));
  } catch (e) {
    /* sin almacenamiento o sin cuota: se usa la lista en memoria */
  }
};

// { at, arboles } o null si no hay nada guardado (o no se puede leer).
export const leerArbolesCache = (instalacion) => {
  try {
    const t = localStorage.getItem(claveArboles(instalacion));
    if (!t) return null;
    const c = JSON.parse(t);
    if (!c || !Array.isArray(c.arboles)) return null;
    return { at: Number.isFinite(c.at) ? c.at : null, arboles: normalizarArboles(c.arboles) };
  } catch (e) {
    return null;
  }
};
